module.exports = __webpack_public_path__ + "img/85a8ce7.png";